import { KeycloakAuthorization } from './KeycloakAuthorization';

export function createAuthorization(tokens, settings) {
  return new KeycloakAuthorization(tokens, settings.get('keycloak'));
}



// WEBPACK FOOTER //
// ./src/services/keycloak.js